export default __webpack_public_path__ + "static/media/aequalis14.8aae2097.pdf";